<template>
  <a-row type="flex" justify="space-between" align="top">
    <a-col :span="12">
      <a-row type="flex">
        <a-col :span="24" class="titulo">Listas de contactos</a-col>

      </a-row>
      <a-row type="flex" justify="space-between" style="margin-bottom: 30px">
        <a-col :span="6">
            <a-input
              v-decorator="['nombre']"
              class="shadowInputs w-100"
              placeholder="Escriba para buscar"
              v-model="buscar"
            />
        </a-col>
        <a-col :span="6">
          <a-select
              style="width: 100%"
              v-decorator="['pais', {rules: [{ required: true, message: 'Ingrese un nombre para esta lista' }]} ]"
              class="shadowInputs" v-model="buscar_pais">
            <a-select-option v-for="itemPais in PAISES" :key="'pais_' + itemPais.id" :value="itemPais.id">
              {{itemPais.emoji}} {{ itemPais.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="12"> <a-button type="primary" size="large" @click="abrirFormularioLista()">Agregar nueva lista</a-button></a-col>
      </a-row>
    </a-col>
    <a-col :span="12" />
    <a-col :span="16" style="word-break: break-all; background-color: white; padding: 10px; border-radius: 5px;" class="shadow">
      <a-table :columns="columnsListTable" :dataSource="items" :pagination="pagination" rowKey="id" >
        <span slot="pais" slot-scope="text, record">
          {{ getCountryById(text) ? getCountryById(text).emoji + ' ' + getCountryById(text).name : ' - ' }}
        </span>
        <span slot="cantidad" slot-scope="text, record">
          {{ format_number(text) }}
        </span>

        <span class="nowrap" slot="action" slot-scope="text, record">
          <a-button class="margin" type="primary" title="Eliminar" shape="circle" icon="delete" @click="showDeleteListConfirm(record.id)" ></a-button>
          <a-popconfirm
              v-if="'update_endpoint' in record && record.update_endpoint != '' && record.update_endpoint != null"
              title='Eliminar los contactos de la lista, y cargarlos de nuevo no actualizar la lista con contactos nuevos?'
              ok-text="Eliminar contactos"
              cancel-text="Actualizar contactos"
              @confirm="updateMailList(record.id, true)"
              @cancel="updateMailList(record.id, false)"
          >
            <a-button class="margin" :loading="record.loading" type="primary" title="Actualizar lista" shape="circle" icon="reload" ></a-button>
          </a-popconfirm>
          <a-button class="margin" type="primary" title="Actualizar lista" v-else shape="circle" icon="reload" disabled ></a-button>
          <a-button class="margin" type="primary" title="Descargar" shape="circle" icon="download" @click="downloadWpp(record.id, record.nombre)" ></a-button>
        </span>
      </a-table>
    </a-col>
    <a-col :span="6">
      <a-spin :spinning="loadingCreateList">
        <a-form
            v-if="openedListForm"
            layout="vertical"
            :form="formLista"
        >
          <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">Crear Nueva Lista:</h1>
          <a-form-item>
          <span slot="label">
            Nombre&nbsp;
            <a-tooltip title="Ingrese el nombre de esta lista para luego poder identificarla.">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
            <a-input
                v-decorator="['nombre', {rules: [{ required: true, message: 'Ingrese un nombre para esta lista' }]}]"
                class="shadowInputs"
            />
          </a-form-item>

          <a-form-item>
          <span slot="label">
            País&nbsp;
            <a-tooltip title="Seleccione el país al cual pertenece esta lista.">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
            <a-select
                v-decorator="['pais', {rules: [{ required: true, message: 'Ingrese un nombre para esta lista' }]} ]"
                class="shadowInputs">
              <a-select-option v-for="itemPais in PAISES" :key="'pais_' + itemPais.id" :value="itemPais.id">
                {{itemPais.emoji}} {{ itemPais.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
          <span slot="label">
            Endpoint
            <a-tooltip title="Ingrese el endpoint de esta lista para poder actualizar con un endpoint externo.">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
            <a-input
                v-decorator="['update_endpoint', {rules: [{ required: false }]}]"
                class="shadowInputs"
            />
          </a-form-item>

          <a-form-item>
          <span slot="label">
            Cargar Lista&nbsp;
            <a-tooltip title="Carge un archivo CSV con los contactos de la lista">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
            <div class="container">
              <div class="large-12 medium-12 small-12 cell">
                <label>Archivo formato .csv
                  <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                </label>
              </div>
            </div>
          </a-form-item>

          <a-form-item>
            <a-row type="flex" justify="end" align="middle" :gutter="20">
              <a-col><a-button @click="submitLista" :disabled="file == '' && (formLista.getFieldsValue()['update_endpoint'] === '' || typeof(formLista.getFieldsValue()['update_endpoint']) === 'undefined')" :loading="uploading" type="primary" html-type="submit" size="large" >Crear Lista</a-button></a-col>
              <a-col><a-button @click="openedListForm = false" size="large">Descartar</a-button></a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-col>
  </a-row>
</template>

<script>
import utils from '../service/service.js'
import countries from "@/service/countries";
export default {
  name: 'gestorListas',
  props: {

  },
  mixins:[utils, countries],
  data() {
    let columnsListTable = [
      { title: 'ID', dataIndex: 'id', width: '70px', sorter: function(a,b){ return a.id - b.id }  },
      { title: 'Nombre', dataIndex: 'nombre' , sorter: function(a, b){ return a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase())},},
      { title: 'Última actualización', dataIndex: 'modificado_el', width: '200px', sorter: function(a, b){ return new Date(a.modificado_el) - new Date(b.modificado_el);},},
      { title: 'Cantidad', dataIndex: 'cantidad', width: '110px', scopedSlots: { customRender: 'cantidad' }, sorter: function(a,b){ return a.cantidad - b.cantidad} ,},
      { title: 'Acciones', scopedSlots: { customRender: 'action' }, width: '95px' },
    ];
    if(process.env.VUE_APP_COUNTRY_FUNCTIONALITY === "on") {
      columnsListTable.splice(2, 0, { title: 'País', dataIndex: 'id_pais', scopedSlots: { customRender: 'pais' }, width: '100px', sorter: function(a,b){ return a.id_pais - b.id_pais }, })
    }
    return {
       buscar:'',
       buscar_pais:'País',
       display_data:[],
       current: 1,
       search: '',
       cantidadPorPagina:3,
       uploadData: {},
       pagination: {pageSize: 8},
       file: '',
       uploading: false,
       listas:[
      ],
      columnsListTable,
      openedListForm: false,
      loadingCreateList: false
    }
  },
  computed: {
    items() {
      return this.listas.filter(item => {
        if(this.buscar_pais !== 'País') {
          return item.nombre.toLowerCase().includes(this.buscar.toLowerCase()) && item.id_pais === this.buscar_pais;
        }
        return item.nombre.toLowerCase().includes(this.buscar.toLowerCase());
      });
    },

  },
  mounted: function() {
    this.getListas();
  },
  methods:{
    showDeleteListConfirm(id) {
      var $this = this;
      this.$confirm({
        title: '¿Estas seguro que queres eliminar esta Lista?',
        content: 'Una vez eliminada esta lista se perdera registro.',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          $this.sendRequest({
            method: 'POST',
            url: `listas/delete/${id}`,
            data: {},
          }).then(({ code, message }) => {
            if (code === 200) {
              $this.$message.success("Lista eliminada")
              $this.getListas();
            } else {
              $this.$swal({
                icon: "warning",
                title: "¡Lo sentimos!",
                text: message,
              });
            }
          })


        },
        onCancel() {
        },
      });
    },
    updateMailList(id, resetList) {

      let item = this.listas.filter((item) => item.id === id)

      item[0].loading = true;
      item[0].nombre = item[0].nombre + ' '; //sin esto no se da cuenta que la lista se actualizo y no refresca el componente

      var currentDateTime = new Date();
      this.sendRequest({
        url:'listas/external/update/' + id + '?' + currentDateTime.getTime(),
        method: 'POST',
        data: {
          resetList
        }
      }).then(({data, code, message}) => {
        if(code !== 200) {
          this.$message.error(message);
        } else {
          this.$message.success("Lista actualizada. se agregaron " + data + ' contactos');
          this.getListas();
        }
      })
    },

    abrirFormularioLista(){
      this.formLista = this.$form.createForm(this);
      this.openedListForm = true;
    },
    submitLista(e){

      this.formLista.validateFields(
        async (err) => {
          if (!err) {
            this.loadingCreateList = true;
            var fields = this.formLista.getFieldsValue();
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('nombre', fields["nombre"]);
            formData.append('id_pais', fields["pais"] ? fields["pais"] : 1);
            formData.append('update_endpoint', fields["update_endpoint"] ? fields["update_endpoint"] : null);

            const { code, data, message } = await this.sendRequest({
              method: 'POST',
              url: `listas/new`,
              data: formData,
              sendFile: true
            })
            this.loadingCreateList = false;
            if (code === 200) {
              this.getListas();
              this.openedListForm = false;
              if(!data.list) {
                this.$message.success("Lista creada");
              } else {
                this.$swal({
                  icon: "success",
                  title: "Lista Creada",
                  html: `<p>Contactos Agregados: ${data.count}</p><p>Repetidos: ${data.errors.duplicated}</p><p>Invalidos: ${data.errors.invalid}</p>`,

                });
              }
            } else {
              this.$swal({
                icon: "warning",
                title: "¡Lo sentimos!",
                text: message,
              });
            }
          }
        },
      );
    },
    format_number(num){
      if(!isNaN(num))
        return new Intl.NumberFormat().format(num);
      else
        return '-'
    },
    async getListas(){
      const { data } = await this.sendRequest({
          method: 'GET',
          url: 'listas',
      })
      this.listas = data;

    },handleFileUpload(){
      this.file = this.$refs.file.files[0];
    },
    downloadWpp(id, name) {
      const currentDateTime = new Date();

      this.sendRequest({
        url:`listas/download/${id}`,
        method: 'GET'
      }).then((data) => {
        const href = URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `${name}.csv`); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .titulo{
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #2c3e50;
  }
  .shadow {
    box-shadow: 2px 1px 5px -4px;
  }
  .shadowInputs {
    box-shadow: 1px 1px 5px -5px;
  }
  .nowrap{
    display: inline-flex;
  }
  .margin {
    margin: 0 2.5px;
  }
</style>




